import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Orders from "./views/Orders.vue";
import Employees from "./views/Employees.vue";
import Customers from "./views/Customers.vue";
import SigninPage from "./views/SigninPage.vue";
import Store from "./store";

Vue.use(Router);
const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/signin",
      name: "signin",
      component: SigninPage,
      meta: {
        requireAuth: false
      }
    },
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        requireAuth: false
      }
    },
    {
      path: "/orders",
      name: "orders",
      component: Orders,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/customers",
      name: "customers",
      component: Customers,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/employees",
      name: "employees",
      component: Employees,
      meta: {
        requireAuth: true
      }
    }
  ]
});

export default router;
